import React from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import DatatableTables from "./DatatableTables"
import MetaTag from "components/Common/Meta-tag"
import { useRole } from "hooks/useRole"
import { useLocation } from "react-router-dom"

function Lead() {
  const { isAdmin } = useRole()
  const location = useLocation()

  const title = location?.pathname?.split("lead/")[1] === "sales" ? "All Sales Leads" : "All Purchase Leads"

  return (
    <>
      <MetaTag title={title} />

      <div className="page-content">
        {isAdmin() ? (
          <Breadcrumbs
            title="Dashboard"
            breadcrumbItem={title}
            isBranchFilter
          />
        ) : (
          ""
        )}
        <Container fluid>
          <div className="container-fluid">
            <DatatableTables />
          </div>
        </Container>
      </div>
    </>
  )
}

export default Lead
